interface LogoProps {
  size?: number;
  variant?: 'mark' | 'wordmark' | 'full';
  className?: string;
}

/**
 * Jasr Hub logo evolved from the JASR-AL-VIDA bridge motif.
 * - mark: just the bridge symbol (square, scalable)
 * - wordmark: just "JASR HUB" text
 * - full: bridge + text stacked
 */
export function Logo({ size = 64, variant = 'mark', className }: LogoProps) {
  if (variant === 'wordmark') {
    return (
      <span className={`font-display text-gradient-gold ${className ?? ''}`} style={{ fontSize: size, fontWeight: 600, letterSpacing: '-0.02em' }}>
        JASR HUB
      </span>
    );
  }

  return (
    <div className={`inline-flex flex-col items-center ${className ?? ''}`}>
      <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Outer gold border square */}
        <rect x="2" y="2" width="196" height="196" rx="20" stroke="url(#goldGrad)" strokeWidth="2" fill="none" opacity="0.6"/>

        {/* Suspension bridge — main cables */}
        <path
          d="M 20 130 Q 100 60 180 130"
          stroke="url(#goldGrad)"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
        />
        {/* Lower deck arc */}
        <path
          d="M 18 145 Q 100 95 182 145"
          stroke="url(#goldGrad)"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          opacity="0.85"
        />

        {/* Center pylon */}
        <line x1="100" y1="50" x2="100" y2="150" stroke="url(#goldGrad)" strokeWidth="3" strokeLinecap="round"/>
        <line x1="92" y1="50" x2="108" y2="50" stroke="url(#goldGrad)" strokeWidth="3" strokeLinecap="round"/>
        <line x1="96" y1="58" x2="104" y2="58" stroke="url(#goldGrad)" strokeWidth="2" strokeLinecap="round"/>

        {/* Suspension lines */}
        <line x1="60" y1="92" x2="60" y2="138" stroke="url(#goldGrad)" strokeWidth="1" opacity="0.5"/>
        <line x1="80" y1="78" x2="80" y2="142" stroke="url(#goldGrad)" strokeWidth="1" opacity="0.5"/>
        <line x1="120" y1="78" x2="120" y2="142" stroke="url(#goldGrad)" strokeWidth="1" opacity="0.5"/>
        <line x1="140" y1="92" x2="140" y2="138" stroke="url(#goldGrad)" strokeWidth="1" opacity="0.5"/>

        {/* Deck baseline */}
        <line x1="20" y1="150" x2="180" y2="150" stroke="url(#goldGrad)" strokeWidth="2.5" strokeLinecap="round"/>

        <defs>
          <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#BF8F47"/>
            <stop offset="50%" stopColor="#F5E9D0"/>
            <stop offset="100%" stopColor="#BF8F47"/>
          </linearGradient>
        </defs>
      </svg>
      {variant === 'full' && (
        <span className="font-display mt-2 text-gradient-gold" style={{ fontSize: size * 0.32, fontWeight: 600, letterSpacing: '0.05em' }}>
          JASR HUB
        </span>
      )}
    </div>
  );
}
